import React from 'react';
import useReveal from '../hooks/useReveal';
import './Team.css';

const TEAM = [
  {
    name: 'Sajid Ahamed S',
    role: 'Founder',
    tag: 'B.Tech ECE, 4th Year',
    phone: '8015153380',
    email: 'sajidahamedwin@gmail.com',
  },
  {
    name: 'Rasith A',
    role: 'Co-founder',
    tag: 'B.Tech ECE, 4th Year',
    phone: '8807562379',
    email: 'rasithofficial22@gmail.com',
  },
  {
    name: 'S. Sadhish Prabhu',
    role: 'Mentor',
    tag: 'Assistant Professor, Crescent University',
  },
];

export default function Team() {
  const ref = useReveal();
  const gridRef = useReveal();
  return (
    <section className="section team" id="team">
      <div className="container">
        <div className="reveal" ref={ref}>
          <p className="eyebrow">Team</p>
          <h2 className="section-heading">Two engineering founders, one field-tested mentor.</h2>
        </div>

        <div className="team__grid reveal-stagger" ref={gridRef}>
          {TEAM.map((m) => (
            <div className="team__card" key={m.name}>
              <div className="team__avatar">{m.name.split(' ').map((w) => w[0]).slice(0, 2).join('')}</div>
              <h3>{m.name}</h3>
              <span className="team__role">{m.role}</span>
              <p className="team__tag">{m.tag}</p>
              {m.email && (
                <div className="team__contact">
                  <a href={`tel:+91${m.phone}`}>+91 {m.phone}</a>
                  <a href={`mailto:${m.email}`}>{m.email}</a>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
